module.exports = __webpack_public_path__ + "static/media/buy_req_rent_13.279fb18d.png";